'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useTheme } from 'next-themes'
import { useEffect, useState } from 'react'

interface ThemeLogoProps {
  size?: 'small' | 'medium' | 'large'
  increasedSize?: boolean
}

export function ThemeLogo({ size = 'medium', increasedSize = false }: ThemeLogoProps) {
  const { resolvedTheme } = useTheme()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <div className={`bg-transparent ${
        size === 'small' ? `w-${increasedSize ? '[50px]' : '10'} h-${increasedSize ? '[50px]' : '10'}` :
        size === 'large' ? `w-${increasedSize ? '40' : '32'} h-${increasedSize ? '40' : '32'}` :
        `w-${increasedSize ? '[120px]' : '24'} h-${increasedSize ? '[120px]' : '24'}`
      }`} />
    )
  }
  
  const currentTheme = resolvedTheme || 'light'
  
  // Set width and height based on size prop
  const originalDimensions = {
    small: { width: 40, height: 40 },
    medium: { width: 96, height: 96 },
    large: { width: 128, height: 128 }
  }

  const increasedDimensions = {
    small: { width: 50, height: 50 },
    medium: { width: 120, height: 120 },
    large: { width: 160, height: 160 }
  }

  const dimensions = (increasedSize ? increasedDimensions : originalDimensions)[size]
  
  return (
    <div className="relative">
      <Link href="/">
        <Image
          src={currentTheme === 'dark' ? '/white_on_trans.png' : '/black_on_trans.png'}
          alt="GovCon Data Logo"
          width={dimensions.width}
          height={dimensions.height}
          className="transition-all duration-200"
          priority
        />
      </Link>
    </div>
  )
} 